






































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import VueMarkdown from "vue-markdown";
import MainHeader from "@/components/customer-header.vue";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import {
  PostTopic,
  GetTopicList,
  PostGptPlan,
  PostSampleCount,
  UploadFile,
  GetReplyList,
} from "@/request/common";
import Fankui from "@/components/fankui.vue";
@Component({
  components: {
    MainHeader,
    VueMarkdown,
    Fankui,
  },
})
export default class Name extends mixins(listMixin) {
  private cTab: any = "循证";
  private text: any = "";
  private showFankui: any = false;
  private qaList: any = [
    {
      name: "藏医药",
      value: "藏医药",
      // url: "https://zdieijjd.sealosgzg.site/chat/share?shareId=9gy8ko5pwyv4gtls5ng1xwqn",
      url: "https://dify.medkg.cn/chatbot/yLQyp3cAFNMLw2Mx",
    },
    {
      name: "傣医药",
      value: "傣医药",
      url: "",
    },
    {
      name: "黎医药",
      value: "黎医药",
      // url: "https://zdieijjd.sealosgzg.site/chat/share?shareId=nix8x44lhxgcsskm4zeqc1jg",
      url: "https://dify.medkg.cn/chatbot/zzmmt3q3jH06CxAQ",
    },
    {
      name: "满医药",
      value: "满医药",
      url: "",
    },
    {
      name: "蒙医药",
      value: "蒙医药",
      // url: "https://zdieijjd.sealosgzg.site/chat/share?shareId=bcohee2435jsg3go10wmhkxp",
      url: "https://dify.medkg.cn/chatbot/cev3W2DbBsc3rykI",
    },
    {
      name: "苗医药",
      value: "苗医药",
      url: "",
    },
    {
      name: "羌医药",
      value: "羌医药",
      url: "",
    },
    {
      name: "畲医药",
      value: "畲医药",
      url: "",
    },
    {
      name: "彝医药",
      value: "彝医药",
      url: "",
    },
    {
      name: "壮医药",
      value: "壮医药",
      // url: "https://zdieijjd.sealosgzg.site/chat/share?shareId=fb3pclkfjzbv0tfcdy1azkmg",
      url: "https://dify.medkg.cn/chatbot/87yXEC9PXv5xNGye",
    },
    {
      name: "维吾尔医药",
      value: "维吾尔医药",
      // url: "https://zdieijjd.sealosgzg.site/chat/share?shareId=hw0fqqi340v1yqmiir5id2fu",
      url: "https://dify.medkg.cn/chatbot/7mETK8nHz90tOHBe",
    },
    {
      name: "瑶医药",
      value: "瑶医药",
      url: "",
    },
  ];
  private zixunData: any = [];
  private caseList: any = [
    {
      name: "肿瘤科",
      value: "肿瘤科",
      des: "肿瘤科的科研方向主要包括肿瘤分子生物学、肿瘤遗传学、肿瘤免疫学、肿瘤流行病学以及肿瘤治疗学等多个领域，肿瘤治疗学是研究的重点。同时也注重肿瘤预防与筛查的研究。",
    },
    {
      name: "消化科",
      value: "消化科",
      des: "消化科作为医学领域的重要分支，专注于消化系统疾病的诊断、治疗及研究。在研究方向上，消化科侧重于深入理解消化系统疾病的发病机制、病理生理过程以及疾病间的相互作用。",
    },
    {
      name: "妇产科",
      value: "妇产科",
      des: "妇产科作为医学领域的重要分支，专注于女性生殖健康及其相关疾病的预防、诊断与治疗。其研究方向广泛，涵盖了从基础医学研究到临床实践的多个层面。",
    },
    {
      name: "内分泌科",
      value: "内分泌科",
      des: "内分泌科专注于研究人体内分泌系统的生理功能、疾病机制以及相应的诊断与治疗方法。内分泌系统由一系列腺体组成，通过分泌激素来调节和控制人体的生长、发育、代谢和应激反应等生理过程。",
    },
    {
      name: "骨科",
      value: "骨科",
      des: "骨科专注于研究骨骼、关节、肌肉、韧带、神经等运动系统的结构、功能、损伤、疾病及其修复与重建。随着医学技术的不断进步和人们健康意识的提高，骨科的研究方向与重点也在不断更新和发展。",
    },
    {
      name: "心内科",
      value: "心内科",
      des: "心内科专注于心脏及其相关血管系统的生理、病理机制，以及心脏疾病的预防、诊断和治疗。随着医学科技的飞速发展，心内科的研究方向与重点也在不断拓展和深化。",
    },
  ];
  private cQa: any = {};
  private cCase: any = {};
  private showIfram: any = false;
  private dialogUrl: any = "";
  private iframeKey: any = 0;
  private ifShowEdit: any = false;
  private editData: any = {};
  private fanganData: any = {};
  private fanganContent: any = "";
  private ifShowFangan: any = false;
  private tongjiData: any = {};
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private uploadFile(file: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "上传中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading).then((res: any) => {
      this.fanganData.attachment = res.data.file_url;
      this.$forceUpdate();
    });
  }
  private count() {
    if (!this.tongjiData["试验组均值"] && this.tongjiData["试验组均值"] !== 0) {
      this.$message.warning("请输入试验组均值");
      return;
    }
    if (
      !this.tongjiData["试验组标准差"] &&
      this.tongjiData["试验组标准差"] !== 0
    ) {
      this.$message.warning("请输入试验组标准差");
      return;
    }
    if (!this.tongjiData["对照组均值"] && this.tongjiData["对照组均值"] !== 0) {
      this.$message.warning("请输入对照组均值");
      return;
    }
    if (
      !this.tongjiData["对照组标准差"] &&
      this.tongjiData["对照组标准差"] !== 0
    ) {
      this.$message.warning("请输入对照组标准差");
      return;
    }
    if (
      !this.tongjiData["试验/对照样本量比值"] &&
      this.tongjiData["试验/对照样本量比值"] !== 0
    ) {
      this.$message.warning("请输入试验/对照样本量比值");
      return;
    }
    const params: any = {
      treatment_mean: this.tongjiData["试验组均值"],
      treatment_std: this.tongjiData["试验组标准差"],
      control_mean: this.tongjiData["对照组均值"],
      control_std: this.tongjiData["对照组标准差"],
      sample_ratio: this.tongjiData["试验/对照样本量比值"],
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    PostSampleCount(this, params, loading).then((res: any) => {
      loading.close();
      this.tongjiData["对照组"] = res.data["对照组"];
      this.tongjiData["试验组"] = res.data["试验组"];
      this.$forceUpdate();
    });
  }
  private reset() {
    this.tongjiData = {};
  }
  private tijiao() {
    if (!this.fanganData.disease_name) {
      this.$message.warning("请输入研究方案名称！");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    PostGptPlan(this, this.fanganData, loading).then((res: any) => {
      loading.close();
      this.ifShowFangan = true;
      this.fanganData = {};
      this.fanganContent = res.data;
    });
  }
  private addTopic() {
    if (!this.text) {
      this.$message.warning("请输入你想要咨询的内容！");
      return;
    }
    const params: any = {
      name: this.text,
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    PostTopic(this, params, loading).then((res: any) => {
      this.$message.success("提交成功！");
      this.search();
      this.text = "";
    });
  }
  private openHuifu(item: any) {
    this.editData = JSON.parse(JSON.stringify(item));
    //换成接口请求
    const params: any = {
      params: {
        topic: item.id,
      },
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetReplyList(this, params, loading).then((res: any) => {
      if (res.data.length > 0) {
        this.editData.replay = res.data[0].content;
      }
      this.ifShowEdit = true;
      console.log(this.editData);
    });
  }
  private changeTab(val: any) {
    // if (val == "样本量统计") {
    //   window.open('http://116.196.73.86:3838/SampleSize_Ldq/');
    //   return;
    // }
    this.cTab = val;
    this.cQa = {};
    this.cCase = {};
    if (val == "人工咨询") {
      this.search();
    } else if (val == "定制方案") {
      this.fanganData = {};
      this.fanganContent = "";
      this.ifShowFangan = false;
    }
  }
  private changeCase(item: any) {
    this.cCase = item;
    this.$forceUpdate();
  }
  private changeQa(item: any) {
    if (!item.url) {
      return;
    }
    this.cQa = item;
  }
  private changeDialog() {
    if (!this.cQa.url) {
      this.$message.warning("正在开发中！");
      return;
    }
    // 拦截未登录
    const token = this.$store.state.token;
    const user = this.$store.state.user;
    if (!token || !user || (!user.userId && !user.id)) {
      this.$confirm("查看更多内容请先登录", "登录", {
        customClass: "commonConfirm",
      }).then(() => {
        // 跳转登录
        this.$router.push("/access/login");
      });
    } else {
      this.openFreshDialog();
    }
  }
  private openFreshDialog() {
    this.showIfram = false;
    this.dialogUrl = "about:blank";
    this.iframeKey = Date.now();
    this.$nextTick(() => {
      this.dialogUrl = this.buildFreshChatUrl(this.cQa.url);
      this.iframeKey = Date.now() + 1;
      this.showIfram = true;
    });
  }
  private buildFreshChatUrl(baseUrl: string) {
    if (!baseUrl) {
      return "";
    }
    const separator = baseUrl.indexOf("?") > -1 ? "&" : "?";
    // 添加新会话参数和时间戳，避免复用上次会话缓存
    return `${baseUrl}${separator}new_chat=1&conversation_id=&_t=${Date.now()}`;
  }
  private closeDialog() {
    this.cQa = {};
    this.dialogUrl = "";
    this.showIfram = false;
  }
  private openFankui() {
    this.showFankui = true;
  }

  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        ordering: this.filters.ordering,
        page: this.filters.current_page,
        limit: 10,
      },
    };
    GetTopicList(this, params, loading).then((res: any) => {
      this.zixunData = res.data;
      this.filters.total_count = res.total;
      if (this.zixunData.length > 0) {
        this.ifShowEmpty = false;
      } else {
        this.ifShowEmpty = true;
      }
    });
  }
}
